/** Indian GSTIN: 15 chars — 2-digit state + 10-char PAN + 3-char entity/check (e.g. 33AAACH7409R1Z8) */
export const formatIndianGstNumber = (value) => {
  const raw = String(value ?? '').toUpperCase().replace(/[^0-9A-Z]/g, '');
  let result = '';
  for (let i = 0; i < raw.length && result.length < 15; i++) {
    const ch = raw[i];
    const pos = result.length;
    if (pos < 2) {
      if (/[0-9]/.test(ch)) result += ch;
    } else if (pos < 7) {
      if (/[A-Z]/.test(ch)) result += ch;
    } else if (pos < 11) {
      if (/[0-9]/.test(ch)) result += ch;
    } else if (pos === 11) {
      if (/[A-Z]/.test(ch)) result += ch;
    } else if (/[0-9A-Z]/.test(ch)) {
      result += ch;
    }
  }
  return result;
};

export const isValidIndianGstNumber = (value) =>
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(formatIndianGstNumber(value));
